import { render, staticRenderFns } from "./myRepair.vue?vue&type=template&id=5e4cbb8e&"
import script from "./myRepair.vue?vue&type=script&lang=js&"
export * from "./myRepair.vue?vue&type=script&lang=js&"
import style0 from "./myRepair.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports